import type { ReactNode } from 'react';
import { Footer } from './Footer';
import { Header } from './Header';

export function PageShell({ children }: { children: ReactNode }) {
  return (
    <div id="top">
      <a className="skip-link" href="#content">Pular para o conteúdo</a>
      <Header />
      <main id="content">{children}</main>
      <Footer />
    </div>
  );
}
